<mon-side-menu [menu]="menu" [agreement]="agreement"></mon-side-menu>